module.exports = __webpack_public_path__ + "static/media/rd_station_cor.eb22135f.svg";